import api from '../client';

const orgService = {
  getSettings: async () => {
    try {
      const response = await api.get('/settings/organization');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  updateSettings: async (data) => {
    try {
      const response = await api.patch('/settings/organization', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default orgService;
